module.exports = __webpack_public_path__ + "media/react/assets/imgs/shot-05bc876dec8f0db08284f5d9d9a5eab9.png";